// Start of base Google Chart options

export const GoogleChartAnimationDefaultOptions: any = {
    duration: 1500,
    easing: "out",
    startup: true,
}
export const GoogleChartAreaDefaultOptions: any = {
    top: "20%",
    left: "7%",
    height: "77%",
    width: "100%",
    bottom: "20%"
}

export const GoogleComboChartAreaDefaultOptions: any = {
    top: "20%",
    left: "17%",
    height: "77%",
    width: "100%",
    bottom: "15%"
}
export const GoogleGroupStackedChartAreaDefaultOptions: any = {
    top: "20%",
    left: "8%",
    height: "77%",
    width: "100%",
    bottom: "25%"
}

export const GoogleChartBaseDefaultOptions: any = {
    animation: GoogleChartAnimationDefaultOptions,
    chartArea: GoogleChartAreaDefaultOptions,
    legend: { position: "top", alignment: 'center', maxLines: 3, textStyle: { color: "gray", fontSize: 11.5 } },
    tooltip: { trigger: "hover", showColorCode: true },
    dataOpacity: "0.9",
}

// Default options, without animation
const { animation, ...chartOptionsDisabledAnimation } = GoogleChartBaseDefaultOptions;
// End of base Google Chart options

export const GoogleColumnChartDefaultOptions: any = {
    ...GoogleChartBaseDefaultOptions,
    vAxis: {
        textStyle: { color: "gray" }, viewWindow: { min: 0 }
    },
    hAxis: {
        textStyle: { fontSize: 10, color: "gray" }, viewWindow: { min: 0 }
    },
    annotations: {
        textStyle: {
            fontSize: 9
        },
    }
};



export const GoogleColumnChartNoAnimationDefaultOptions: any = {
    ...chartOptionsDisabledAnimation,
    vAxis: { textStyle: { color: "gray", minValue: 0 } },
    hAxis: { textStyle: { fontSize: 10, color: "gray", viewWindow: { min: 0 } } },
};

export const GoogleComboChartDefaultOptions: any = {
    ...GoogleChartBaseDefaultOptions,
    vAxis: { textStyle: { color: "gray", width: 20 } },
    hAxis: { textStyle: { fontSize: 10, color: "gray" } },
    animation: GoogleChartAnimationDefaultOptions,
    chartArea: GoogleComboChartAreaDefaultOptions,
    legend: { position: "top", alignment: 'center', maxLines: 3, textStyle: { color: "gray", fontSize: 11.5 } },
    tooltip: { trigger: "hover", showColorCode: true },
    dataOpacity: "0.9",
};
export const GoogleComboChartNoAnimationDefaultOptions: any = {
    ...chartOptionsDisabledAnimation,
    vAxis: { textStyle: { color: "gray", width: 20 } },
    hAxis: { textStyle: { fontSize: 10, color: "gray" } },
    chartArea: GoogleComboChartAreaDefaultOptions,
    legend: { position: "top", alignment: 'center', maxLines: 3, textStyle: { color: "gray", fontSize: 11.5 } },
    tooltip: { trigger: "hover", showColorCode: true },
    dataOpacity: "0.9",
};


export const GoogleGroupedStackedChartDefaultOptions = {
    ...GoogleChartBaseDefaultOptions,
    isStacked: true,
    chartArea: GoogleGroupStackedChartAreaDefaultOptions,
    bar: { groupWidth: "90%" },
    vAxis: {
        textStyle: { color: "gray" }, format: "short", viewWindow: { min: 0 }
    },
    hAxis: {
        textStyle: { fontSize: 10, color: "gray" },
        maxAlternation: 1,
        viewWindow: { min: 0 }
    },
    alwaysOutside: true
};



export const GoogleGroupedStackedMinMaxChartDefaultOptions = {
    ...GoogleChartBaseDefaultOptions,
    isStacked: true,
    chartArea: GoogleGroupStackedChartAreaDefaultOptions,
    bar: { groupWidth: "90%" },
    vAxis: {
        textStyle: { color: "gray" }, format: "short", viewWindow: { min: 0, max: 10 },
    },
    hAxis: {
        textStyle: { fontSize: 10, color: "gray" },
        maxAlternation: 1

    },
    alwaysOutside: true
};

export const GoogleGroupedStackedChartNoAnimationOptions = {
    ...chartOptionsDisabledAnimation,
    isStacked: true,
    bar: { groupWidth: "90%" },
    vAxis: {
        textStyle: { color: "gray" }, format: "short", viewWindow: {
            min: 0
        }
    },
    hAxis: {
        textStyle: { fontSize: 10, color: "gray" },
        maxAlternation: 1,
        viewWindow: {
            min: 0
        }
    },
};

export const GoogleGroupedStackedChartMinMaxNoAnimationOptions = {
    ...chartOptionsDisabledAnimation,
    isStacked: true,
    bar: { groupWidth: "90%" },
    vAxis: {
        textStyle: { color: "gray" }, format: "short", viewWindow: {
            min: 0
        }
    },
    hAxis: {
        textStyle: { fontSize: 10, color: "gray" },
        maxAlternation: 1,
        viewWindow: {
            min: 0, max: 10
        }
    },
};

export const GoogleGroupedStackedSkillsDevChartPowerpointPrintOptions = {
    ...GoogleGroupedStackedChartNoAnimationOptions,
    chartArea: { width: "90%", height: "90%" },
    vAxis: { textStyle: { color: "gray", fontSize: 8.5 }, format: "short" },
    legend: { position: "top", alignment: 'center', maxLines: 3, textStyle: { color: "gray", fontSize: 9 } },
    annotations: {
        textStyle: {
            fontSize: 12
        },
    }
};

export const GooglePieChartPowerPointPrintOptions = {
    animation: GoogleChartAnimationDefaultOptions,
    pieSliceTextStyle: { fontSize: 10 },
    is3D: true,
    tooltip: { showColorCode: true },
    chartArea: { width: "90%", height: "75%" },
    sliceVisibilityThreshold: 0,
    legend: {
        position: "right",
        textStyle: { color: "gray", fontSize: 11.5 }
    },
};

export const GooglePieChartDefaultOptions = {
    animation: GoogleChartAnimationDefaultOptions,
    pieSliceTextStyle: { fontSize: 10 },
    is3D: true,
    tooltip: { showColorCode: true },
    chartArea: { width: "90%", height: "75%" },
    sliceVisibilityThreshold: 0,
    legend: {
        position: "top",
        maxLines: 3,
        textStyle: { color: "gray", fontSize: 11.5 },
        alignment: "center"
    },
};


export const GoogleHalfPieChartDefaultOptions = {
    animation: GoogleChartAnimationDefaultOptions,
    pieSliceTextStyle: { fontSize: 10.5 },
    pieHole: 0.4,
    is3D: false,
    tooltip: { trigger: 'none' },
    chartArea: { width: "90%", height: "85%" },
    sliceVisibilityThreshold: 0,
    pieStartAngle: -90,
    legend: {
        position: "top",
        maxLines: 3,
        textStyle: { color: "gray", fontSize: 11 },
        alignment: "center",
    },

};